import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EditValueContentDialogComponent } from '../edit-value-content-dialog/edit-value-content-dialog.component';
import { SettingsService } from '../service/settings.service';
import { languagesList, languagesList_ } from 'na-lib';
import { deepCopy } from 'na-lib';
import { TranslateService } from '@ngx-translate/core';
import { TWO_DIGIT_DATE_FORMATS, validateDateFormat } from '../validators/formValidators.dt';
import { MAT_DATE_FORMATS } from '@angular/material/core';

@Component({
    selector: 'app-content-edit-dialog',
    templateUrl: './content-edit-dialog.component.html',
    styleUrls: ['./content-edit-dialog.component.css'],
    providers: [{ provide: MAT_DATE_FORMATS, useValue: TWO_DIGIT_DATE_FORMATS }],
    standalone: false
})

export class ContentEditDialogComponent implements OnInit {
  dialogForm!:FormGroup
  dialogData:any
  oldData:any
  dataValues:any=[]
  values:any
  type:any
  currentType: string | null = null;
  contentUserRights_update:any
  languagesList:any = languagesList
  addedLangKeys = new Set<string>();
  availableLangList: { key: string; value: string }[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any[],
    public dialogRef: MatDialogRef<ContentEditDialogComponent>,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private settingsService:SettingsService,
    private translate:TranslateService ){
      dialogRef.disableClose = true;
      const currentLang = this.translate.currentLang() ?? 'en';
      this.languagesList = deepCopy(languagesList_[currentLang])
  }

  ngOnInit():void{

    this.contentUserRights_update = this.settingsService.modulesRolesRights$.value['content']['U']

    this.settingsService.modulesRolesRights$.subscribe( value => {
      this.contentUserRights_update = this.settingsService.modulesRolesRights$.value['content']['U']
    })
    this.dialogData = this.data
    this.oldData = deepCopy(this.data)

    this.dialogForm = this.fb.group({
      id:[],
      type:[],
      key:[],
      value:[],
      values: this.fb.array([]),
      date:[, validateDateFormat],
      time:[]
    })

    const {id, type, key, value, values } = this.dialogData
    this.dialogForm.patchValue({
      id: id ? id : undefined,
      type: type ? type : undefined,
      key: key ? key : undefined,
      value: value ? value : false,
      date: undefined,
      time: undefined
    })
    this.type=this.dialogData.type

    if(this.type=="string"){
      this.dialogForm.patchValue({
        value:value ? value : undefined
      })
      if (values && typeof values === 'object') {
        Object.entries(values).forEach(([lang, val]) => {
          this.valuesArray.push(this.fb.group({
            lang: [lang],
            value: [val]
          }));
          this.addedLangKeys.add(lang);
        });
      }
    }
    if (this.type == "array") {
      this.dialogForm.value.value.forEach((element: any, index: any) => {
        this.dataValues.push(element);
        this.setCurrentType(element);
      });
    }

    if (this.type == "object") {
      if (this.dialogForm.value.value) {
        this.dialogForm.value.value.forEach((element: any, index: any) => {
          this.dataValues.push(element);
          this.setCurrentType(element);
        });
      }
    }

    if(this.type=="date"){
      let dat = this.dialogData.value
      if(this.dialogData.value==false || this.dialogData.value == undefined){
        if(this.dialogData.creationDate)
        dat = this.dialogData.creationDate
        else
        dat = Date.now()

        this.formatDate(dat)
        this.formatTime(dat)
        this.dialogForm.patchValue({value:dat})
      }
      if(dat.seconds || dat.nanoseconds){
        const fireBaseTime = new Date(
          dat.seconds * 1000 + dat.nanoseconds / 1000000,
        );
        this.formatDate(fireBaseTime)
        this.formatTime(fireBaseTime)
        this.dialogForm.patchValue({value:fireBaseTime})
      }
    }

    this.dialogForm.valueChanges.subscribe( value=>{
      if(value.type!=this.type){
        if(value.type == "boolean" && this.type != "boolean"){
          this.type=value.type
          this.dialogForm.patchValue({value: false})
          
        }
        this.type=value.type
        if(this.type =="array" || this.type=="object"){
          this.dataValues = []
          this.dialogForm.patchValue({value: []})    
        }else{
          this.dataValues = undefined
          this.dialogForm.patchValue({value: undefined})    
        }
      }

      if(this.type=="date"){
        // const alld = value.date + " " + value.time
        // const dateNew = new Date(date)
        // value.value = dateNew
        try{
          let newdate 
          if(value.date){
            newdate = new Date(value.date)
          }

          if(value.time){
            const hoursminute = value.time.split(':')
            const newtime = new Date(value.date).setHours(hoursminute[0], hoursminute[1], 0)
            newdate.setTime(newtime)
          }
          value.value = newdate
        }catch(e){}
      }

    })

    // for string type languages
    this.dialogData.value && Object.keys(this.dialogData.value).forEach(k => this.addedLangKeys.add(k));
    this.updateAvailableLanguages();

  }

  get valuesArray(): FormArray {
    return this.dialogForm.get('values') as FormArray;
  }

  addTranslation(lang: string): void {
    const translationGroup = this.fb.group({
      lang: [lang],
      value: ['']
    });
    this.valuesArray.push(translationGroup);
    this.addedLangKeys.add(lang);
    this.updateAvailableLanguages();
  }
 
  deleteValue(index: number): void {
    const lang = this.valuesArray.at(index).get('lang')?.value;
    this.addedLangKeys.delete(lang);
    this.valuesArray.removeAt(index);
    this.updateAvailableLanguages();
  }

  getLangKey(val: any): string {
    return Object.keys(val)[0];
  }

  updateAvailableLanguages(): void {
    this.availableLangList = Object.entries(this.languagesList)
      .filter(([key]) => !this.addedLangKeys.has(key))
      .map(([key, value]) => ({ key, value: value as string }));
  }

  setCurrentType(element: any): void {
    if (typeof element === 'string') {
      this.currentType = 'text';
    } else if (typeof element === 'number') {
      this.currentType = 'number';
    } else if (typeof element === 'boolean') {
      this.currentType = 'boolean';
    } else if (element instanceof Date || (element.nanoseconds && element.seconds)) {
      this.currentType = 'date';
    } else if (typeof element === 'object') {
      this.currentType = 'object';
    }
  }
  
  addNewValue(type: string) {
    if (this.currentType && this.currentType !== type) {
      // Prevent adding a different type if values exist
      alert('You can only add values of the same type. Please delete all values to change the type.');
      return;
    }

    let data;
    switch (type) {
      case 'text':
        data = '-';
        break;
      case 'number':
        data = 0;
        break;
      case 'boolean':
        data = true;
        break;
      case 'date':
        data = new Date();
        break;
      default:
        return;
    }

    this.dataValues.push(data);
    this.dialogForm.patchValue({ value: this.dataValues });

    if (!this.currentType) {
      this.currentType = type; // Set the current type if it's not set
    }
  }

  deleteListValue(value: any, index: number) {
    this.dataValues.splice(index, 1);
    const valueArray = this.dataValues;
    this.dialogForm.patchValue({ value: valueArray });
  
    if (this.dataValues.length === 0) {
      this.currentType = null;
    }
  }
  

  editListValue(string, index){
    const type = typeof string
    this.openDialogEditContentValue(index, string, type)
  }

  onCancelEdit(){
    this.dialogRef.close([this.oldData,false])
  }

  onSaveEdit() {
    const { id, key, type, value, values } = this.dialogForm.value;

    const valuesObj = values.reduce((acc: any, curr: any) => {
      if (curr.lang) {
        acc[curr.lang] = curr.value;
      }
      return acc;
    }, {});

    const data = { id, key, type, value, values: valuesObj };
    this.dialogRef.close([data, true]);
}

  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    this.dialogForm.patchValue({date: [year, month, day].join('-')})
    return [year, month, day].join('-');
  }

  formatTime(date){
    var dateToinput=""
    const d = new Date(date)

    let hours = d.getHours()
    const minutes = d.getMinutes()
    const m = d.toTimeString()
    if(hours<10){
      const h = '0' + hours
      dateToinput = h + ":" + minutes
      if(minutes<10){
        const m = '0' + minutes
        dateToinput = h + ":" + m
  
      }else{
        dateToinput = h + ":" + minutes
  
      }
    }else{
      dateToinput = hours + ":" + minutes
      if(minutes<10){
        const m = '0' + minutes
        dateToinput = hours + ":" + m
  
      }else{
        dateToinput = hours + ":" + minutes
  
      }
    }

    this.dialogForm.patchValue({time:dateToinput})
   return dateToinput
  }

  openDialogEditContentValue(index:string, data:any ,type:any):void{

    let dialogRef= this.dialog.open(EditValueContentDialogComponent, {
      data: [index, data, type]
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result[1]){
        this.dataValues[index]= result[0]
        this.dialogForm.patchValue({value: this.dataValues})
      }
    });
  }

  isNumber(val): boolean { return typeof val === 'number'; }
  isString(val): boolean { return typeof val === 'string'; }
  isBoolean(val): boolean { return typeof val === 'boolean'; }
  isObject(val): boolean { 
    return typeof val === 'object'; }
  isDate(val): string { 
    let dateToShow =""
    let date = false
    if(val.nanoseconds){
      const dateHour = new Date(val)
      dateToShow = dateHour.toTimeString()
      date=true
      return dateToShow;
    }
    return dateToShow
  }

  isArray(valu): boolean { 
    return true; 
  }

  isDateTime(element){
    let dateValue
    dateValue = element

    if(element){
      if(element['_nanoseconds'] || element['_seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['_seconds'] * SEC_TO_MS_MULTIPLIER + element['_nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        dateValue = date.toUTCString()//----------
      }

      if(element['nanoseconds'] || element['seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['seconds'] * SEC_TO_MS_MULTIPLIER + element['nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        dateValue = date.toUTCString()//----------
      }

      if( typeof element === 'object'){
        const date = new Date(element)
        dateValue = date.toUTCString()//----------
      }

      if( typeof element === 'string'){
        const date = new Date(element)
        dateValue = date.toUTCString()//----------
      }
    }
   return dateValue
  }
}